import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding:0;
  display: flex;
  justify-content: center;

	@media print {
		display: none;
	}
`;

export const PlayerDiv = styled.div`
  display: inline-block;
  max-width: 600px;
  max-height: 340px;
`;